import PropTypes from 'prop-types'
import React from 'react'
import { Link as ReactRouterLink } from 'react-router'
import classNames from 'classnames'
import './Link.css'

const iconMapping = {
  rightArrow: 'rightArrow'
}

function getIconClass(iconName) {
  const className = iconMapping[iconName]
  if (!className) {
    throw new Error(`Invalid icon type '${iconName}' for <Link />`)
  }
  return className
}

const Link = props => {
  const { href, children, target, onClick, rel, icon, underline } = props
  const role = href === '#' ? 'button' : null
  const classes = {
    Link: true,
    'Link--underline': underline
  }

  if (icon) {
    classes[getIconClass(icon)] = true
  }

  const attrs = {
    role,
    className: classNames(classes),
    target,
    rel,
    onClick: e => {
      // Prevent changing the url and auto scrolling to the top of the page
      // when the link is behaving like a button
      if (role === 'button') {
        e.preventDefault()
      }

      if (onClick) {
        onClick(e)
      }
    }
  }

  // Don't pass hash links to react-router because it navigates to the root (/)
  if (rel === 'external' || href.startsWith('#')) {
    attrs.href = href
  } else {
    attrs.to = href
  }

  return <ReactRouterLink {...attrs}>{children}</ReactRouterLink>
}

Link.defaultProps = {
  underline: true,
  href: '#'
}

Link.propTypes = {
  href: PropTypes.string,
  children: PropTypes.any.isRequired,
  target: PropTypes.string,
  onClick: PropTypes.func,
  rel: PropTypes.string,
  icon: PropTypes.string,
  underline: PropTypes.bool
}

Link.displayName = 'Link'

export default Link



// WEBPACK FOOTER //
// ./ui/Link.js